module.exports = __webpack_public_path__ + "static/media/Hen-Logo.f8b1b766.jpg";